// client/src/hooks/infrastructure/usePresenceHeartbeat.ts
//
// PRESENZA ONLINE (2 Nov 2026): il pannello admin mostra Online / Ultimo
// accesso. Ogni richiesta autenticata aggiorna già `last_seen_at`, ma un
// utente fermo su una pagina risultava offline. Questo heartbeat gira ogni
// 2 minuti SOLO a scheda visibile (nessun consumo in background) e tiene
// fresco lo stato senza polling pesante.
import { useEffect } from "react";

import { apiFetch } from "@/api/core/apiFetch";
import useAuthStore from "@/store/useAuthStore";

const HEARTBEAT_MS = 2 * 60 * 1000;

export function usePresenceHeartbeat(): void {
  const userId = useAuthStore((s) => s.user?.id);

  useEffect(() => {
    if (!userId) return;
    let stopped = false;

    const beat = () => {
      if (
        stopped ||
        (typeof document !== "undefined" &&
          document.visibilityState !== "visible")
      ) {
        return;
      }
      apiFetch("/api/auth/heartbeat", { method: "POST" }).catch(() => {
        /* best effort: non disturbare l'utente */
      });
    };

    const onVisibility = () => {
      if (document.visibilityState === "visible") beat();
    };

    beat();
    const timer = window.setInterval(beat, HEARTBEAT_MS);
    document.addEventListener("visibilitychange", onVisibility);

    return () => {
      stopped = true;
      window.clearInterval(timer);
      document.removeEventListener("visibilitychange", onVisibility);
    };
  }, [userId]);
}

export default usePresenceHeartbeat;
